import React from 'react';

const redRibbon = 'https://santaplaya-bucket.s3.amazonaws.com/red_ribbon.webp';

// Define cocktail items.
// For items with no description, we generate a default description.
const cocktails = [
  {
    name: 'CAMARON',
    price: '$19',
    description: 'Fresh shrimp, lightly seasoned and chilled for a zesty bite.',
  },
  {
    name: 'CAMARON Y PULPO',
    price: '$22',
    description: 'A delightful combo of shrimp and octopus with a tangy sauce.',
  },
  {
    name: 'VUELVE A LA VIDA',
    price: '$30',
    description: 'Shrimp, octopus, scallop, and oysters.',
  },
];

const CocktailsSection: React.FC = () => {
  return (
    <section className="relative w-full">
      {/* Title Area */}
      <div className="bg-basic text-center w-full px-4 lg:px-24 py-12">
        <div className="flex justify-center items-center">
          {/* Left Ribbon */}
          <div className="mr-2 self-center">
            <img src={redRibbon} alt="Ribbon Left" className="w-24" />
          </div>
          {/* Main Title */}
          <h2 className="font-charles text-sea text-5xl md:text-6xl">
            COCTELES
          </h2>
          {/* Right Ribbon (flipped) */}
          <div className="ml-2 !scale-x-[-1] self-center">
            <img src={redRibbon} alt="Ribbon Right" className="w-24" />
          </div>
        </div>
        {/* Subtitle / Translation */}
        <p className="font-prosto text-sea text-2xl md:text-3xl mt-2">
          SEAFOOD COCKTAILS
        </p>
      </div>

      {/* Items Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 max-w-4xl mx-auto">
        {cocktails.map((item, idx) => (
          <div
            key={idx}
            className="bg-sea p-4 flex flex-col items-center text-center shadow-md"
          >
            <h3 className="font-charles text-white text-2xl mb-2">
              {item.name}
            </h3>
            <p className="font-charles text-maroon text-3xl mb-2">
              {item.price}
            </p>
            <p className="font-prosto text-white text-sm">{item.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CocktailsSection;
